import { FaApple, FaGlobe } from 'react-icons/fa';
import { IoExtensionPuzzleOutline, IoLogoGooglePlaystore } from 'react-icons/io5';
import './Button.scss';

const iconMap = {
  Android: <IoLogoGooglePlaystore />,
  IOS: <FaApple />,
  Web: <FaGlobe />,
  Extention: <IoExtensionPuzzleOutline />
};

const bgTypeColorMap = {
  blue: '#ffffff',
  'midnight-slate': '#ffffff',
  default: '#103f57'
};

const Buttons = ({ platform = 'Android', bgType = 'default', children, ...props }) => {
  const icon = iconMap[platform] || null;
  const color = bgTypeColorMap[bgType] || bgTypeColorMap.default;

  return (
    <button
      className="pill-btn"
      style={{
        '--btn-color': color
      }}
      {...props}>
      {icon && <div className="icon">{icon}</div>}
      {children || platform}
    </button>
  );
};

export default Buttons;
